export const SET_CURRENT_ARTICLE = "SET_CURRENT_ARTICLE";
export const SET_AUTHORS = "SET_AUTHORS";
export const SET_HASHTAGS = "SET_HASHTAGS";
export const SET_ARTICLES = "SET_ARTICLES";
export const SET_LATEST_COMMENTS = "SET_LATEST_COMMENTS";
export const ARTICLE_LOADING = "ARTICLE_LOADING";